const validFramerEasingTokens = [
    'linear',
    'easeIn',
    'easeOut',
    'easeInOut',
    'circIn',
    'circOut',
    'circInOut',
    'backIn',
    'backOut',
    'backInOut',
    'anticipate',
];
/**
 * Function that accepts an animation easing token and returns the appropriate value for the framer motion API.
 */
export const framerEase = (token) => {
    if (validFramerEasingTokens.includes(token)) {
        return token;
    }
    else if (token.includes('cubic-bezier')) {
        const cubicBezierValues = token
            .replace(/[^0-9,.]/g, '')
            .split(',')
            .map((item) => parseFloat(item));
        if (cubicBezierValues.length !== 4) {
            throw new Error('Invalid cubic-bezier value provided. Expected 4 values.');
        }
        return cubicBezierValues;
    }
    throw new Error('Invalid value provided. Expected a valid easing token.');
};
/**
 * Function to convert duration tokens (which are provided in milliseconds) to seconds (which framer expects for transition duration and delay).
 */
export const framerDuration = (duration) => {
    const durationInMs = parseFloat(duration);
    if (isNaN(durationInMs)) {
        throw new Error('Invalid duration provided. Expected a parseable string value.');
    }
    return durationInMs / 1000;
};
//# sourceMappingURL=framer.js.map